import { Component, OnDestroy, ViewChild } from '@angular/core';
import { ApiClientService } from '../../../services/api-client.service';
import { DirectoryService } from '../../../services/directory.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { DailyReportsService } from '../../../services/daily-reports.service';
import { DatePipe } from '@angular/common';
import { ConstantsService } from '../../../services/constants.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'daily-reports-detailed-view',
    templateUrl: './daily-reports-detailed-view.component.html',
    styleUrls: ['./daily-reports-detailed-view.component.scss']
})

export class DailyReportsDetailedViewComponent implements OnDestroy {
    @ViewChild('form') form;
    details = '';
    newEntryDate: Date = new Date();
    newEntryTime: string = moment().format('hh:mm A');
    disabledEntrySubmit = false;
    order = 'desc';

    private updateDateTo$;
    public isClickedByDataTo = false;

    constructor(public api: ApiClientService,
                public dailyReportsService: DailyReportsService,
                public directoryService: DirectoryService,
                public authenticationService: AuthenticationService
    ) {
        this.updateDateTo();
    }

    onSubmit(data: any): void {
        const url = `/v1/daily_report/${this.dailyReportsService.selectedItemData.id}.json`;
        this.dailyReportsService.api.patch('domainDailyReports', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            (error) => this.api.errorHandler(error, 'Update failed!')
        );
    }

    updateDateTo(): void {
        this.updateDateTo$ = setInterval(_ => {
            if (!this.isClickedByDataTo) {
                this.newEntryDate = new Date();
                this.newEntryTime = moment().format('hh:mm A');
            }
        }, 1000);
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        this.dailyReportsService.getData();
    }

    setEditModeFor(item, fieldName: string, state: boolean, form?) {
        if(!this.dailyReportsService.selectedItemData.isCanEdit || this.dailyReportsService.selectedItemData.status !== 'draft')
            return;
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
        if(fieldName == 'startDate' || fieldName == 'endDate')
            setTimeout(() => this.initTimepicker('#timepicker'), 300);
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.dailyReportsService.selectedItemData.formFields)
            this.dailyReportsService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        if (form.dirty) {
            if(formField != 'startDate' && formField != 'endDate')
                item[formField] = form.value[formField];
            if(formField == 'building') {
                if(!form.value.building) {
                    toastr.warning('Building must be filled to proceed.');
                    return;
                }

                const building = this.dailyReportsService.buildings.find((item) => +item.id === +form.value.building);
                changedValue = {
                    building: {
                        bdId: form.value.building,
                        name: building ? building.name : null
                    },
                };
            } else if(formField == 'startDate') {

                if(!form.value.startDate || !form.value.startTime) {
                    toastr.warning('All Start Date details must be filled to proceed.');
                    return;
                } else if(this.getDateTimeFromForm('startDate', 'startTime') > new Date(this.dailyReportsService.selectedItemData.endDate)) {
                    toastr.warning('Start Date must be less than End Date.');
                    return;
                }
                changedValue = {startDate: this.getDateTimeFromForm('startDate', 'startTime')};
            } else if(formField == 'endDate') {

                if(!form.value.endDate || !form.value.endTime) {
                    toastr.warning('All End Date details must be filled to proceed.');
                    return;
                } else if(this.getDateTimeFromForm('endDate', 'endTime') < new Date(this.dailyReportsService.selectedItemData.startDate)) {
                    toastr.warning('End Date must be less than Start Date.');
                    return;
                }
                changedValue = {endDate: this.getDateTimeFromForm('endDate', 'endTime')};
            }
            this.onSubmit(changedValue);
            if (form.valid) this.setEditModeForAll(false);
        } else {
            this.setEditModeForAll(false);
        }
    }

    addEntry() {
        if (!this.details) {
            toastr.warning('Details should not be blank.');
            return;
        } else if(!this.form.value['date'] || !this.form.value['time']) {
            toastr.warning('Entry date and time should not be blank.');
            return;
        }

        const data = {
            dailyReport:     this.dailyReportsService.selectedItemData.id,
            dateTo:          this.getDateTimeFromForm('date', 'time'),
            details:          this.details
        };

        this.disabledEntrySubmit = true;

        this.api.post('domainDailyReports', '/v1/daily_report_entry.json', data).subscribe(
            () => {
                this.newEntryDate = null;
                this.newEntryTime = '';
                this.isClickedByDataTo = false;
                this.details = '';
                this.entryTyped(false);
                this.disabledEntrySubmit = false;
                this.updateView('Daily Report entry successfully created');
            },
            error => {
                this.isClickedByDataTo = false;
                this.disabledEntrySubmit = false;
                this.api.errorHandler(error, 'Create Daily Report entry failed');
            }
        );
    }

    editEntry(index, form) {
        if (!form.value['entry' + index]) {
            toastr.warning('Entry should not be blank.');
            return;
        }

        const data = {
            dailyReport:     this.dailyReportsService.selectedItemData.id,
            // dateTo:          this.getDateTimeFromForm('date', 'time'),
            details:          form.value['entry' + index]
        };

        this.disabledEntrySubmit = true;

        const url = `/v1/daily_report_entry/${this.dailyReportsService.selectedItemData.entries[index].id}.json`

        this.api.patch('domainDailyReports', url, data).subscribe(
            () => {
                this.disabledEntrySubmit = false;
                this.updateView('Daily Report entry successfully created');
            },
            error => {
                this.disabledEntrySubmit = false;
                this.api.errorHandler(error, 'Create Daily Report entry failed');
            }
        );
    }

    trackByFn(index, item) {
        return index; // or item.id
    }

    sortEntries(order) {
        this.order = order;
        this.dailyReportsService.selectedItemData.entries.sort((a: any, b: any) => {
            if (new Date(a.createdAt) < new Date(b.createdAt))
                return this.order == 'desc' ? 1 : -1;
            else if (new Date(a.createdAt) > new Date(b.createdAt))
                return this.order == 'desc' ? -1 : 1;
            else
                return 0;
        });
    }

    openTimepicker(id): void {
        $(id).timepicker('showWidget');
    }

    getTime(dateString) {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    getDateTimeFromForm(dateProperty, timeProperty): Date {
        const date = new Date(this.form.value[dateProperty]);
        const time = (<any>document.getElementsByName(timeProperty)[0]).value;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    initTimepicker(id) {
        $(id).timepicker().on('changeTime.timepicker', e => this.form.control.markAsDirty());
    }

    removeEntry(index) {
        swal(ConstantsService.getSwalConfig('Delete Entry', 'Are you sure you want to delete entry?'),
            () => {
                if (!this.disabledEntrySubmit) {
                    this.disabledEntrySubmit = true;
                    const url = `/v1/daily_report_entry/${this.dailyReportsService.selectedItemData.entries[index].id}.json`;
                    this.api.remove('domainDailyReports', url).subscribe(
                        () => {
                            this.disabledEntrySubmit = false;
                            this.updateView('Daily Report entry was deleted successfully');
                        },
                        error => {
                            this.disabledEntrySubmit = false;
                            this.api.errorHandler(error, 'Failed to delete Daily Report entry');
                        }
                    );
                }
            }
        );
    }

    entryTyped(value) {
        this.dailyReportsService.entryTyped = value;
    }

    closeDetailedView() {
        if(!this.dailyReportsService.entryTyped) {
            this.dailyReportsService.toggleDetailedView(null, false);
        } else {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.dailyReportsService.entryTyped = false;
                    this.dailyReportsService.toggleDetailedView(null, false);
                }
            );
        }
    }

    closeEntryEditing(entry, index) {
        if(entry.details == $('#entry' + index)[0].value) {
            if (this.dailyReportsService.entryTyped && !this.details)
                this.dailyReportsService.entryTyped = false;
            entry.editMode = false;
        } else {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.dailyReportsService.entryTyped = false;
                    entry.editMode = false;
                }
            );
        }
    }

    noEntriesEdited() {
        if(this.dailyReportsService.selectedItemData.entries.length > 0) {
            let edited = true;
            this.dailyReportsService.selectedItemData.entries.forEach((entry, index) => {
                if($('#entry' + index)[0] && entry != $('#entry' + index)[0].value)
                    edited = false;
            });
            return edited;
        } else
            return true;
    }

    ngOnDestroy(): void {
        clearInterval(this.updateDateTo$);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-detailed-view/daily-reports-detailed-view.component.ts